import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useFetchWidgetsHojasGasto = () => {
  const [response, setResponse] = useState({})
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    if (loading) {
      return
    }
    setLoading(true)
    axios
      .get(`/hojasgasto/widgets/`)
      .then((request_response) => {
        const data = request_response.data
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!loading) fetchData()
  }, [])

  return { response, error, loading }
}

export default useFetchWidgetsHojasGasto
